import { loginStart, loginSuccess, loginFailure } from 'reducer/authSlice';

import axios from 'axios';
const Base_url = process.env.REACT_APP_BASE_URL;

export const login = (data) => async (dispatch) => {
  try {
    dispatch(loginStart());
    const response = await axios.post(
      `${Base_url}/user/login`,
      {
        employeeId: data.username,
        password: data.password,
        applicationId: 'com.scnl.hcm.portal',
        appVersion: '21',
        loginMode: 'Desktop',
        grant_type: 'password',
      },
      {
        headers: {
          Authorization:
            'Basic YW1sYnZuMDllYzV4dXE3bDVnOXZ2YXJoMWs0eDYwaG06enQ0cGprd3BmeWwyZXZ4OXdnYXl5c254Ym1jcmpuZDg=',
        },
      }
    );
    if (response.data) {
      dispatch(
        loginSuccess({
          isAuthenticated: true,
          userData: response?.data?.data,
          token: response?.data?.data?.access_token,
        })
      );

      //navigate("/");
      return;
    }

    // Assuming the API returns { user, token }
    console.log('login response', response);
  } catch (error) {
    console.log('login error', error, error, error?.response?.data?.message);
    dispatch(loginFailure(error?.response?.data?.message));
  }
};
